import { useUserEventLogger } from '@repo/tracking-service';
import { useCiHistoryController } from '@repo/user-sign';
import { TopNavigation } from '@zenterprise-inc/ui';

import s from '@/components/my/common/layout.module.scss';

export const MyTopNavigation = () => {
  const { softButtonHistoryBack } = useCiHistoryController('exit');
  const { sendClickEvent } = useUserEventLogger();

  const goBack = () => {
    sendClickEvent('my-info_topnav_back');

    softButtonHistoryBack();
  };
  return <TopNavigation.Basic leftIcon={'back'} onLeftClick={goBack} className={s.nav_position} />;
};
